import { render, staticRenderFns } from "./working-from-the-cafe-a45.vue?vue&type=template&id=5536689c"
import script from "./working-from-the-cafe-a45.vue?vue&type=script&lang=js"
export * from "./working-from-the-cafe-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports